import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import EpisodeDetail from "@/pages/EpisodeDetail";

export const Route = createFileRoute("/_app/podcasts/$podcastId/episodes/$episodeId")({
  component: () => (
    <PageGate pageKey="podcasts"><EpisodeDetail /></PageGate>
  ),
});
